import React, { useEffect, useRef } from 'react';
import { useModal } from 'contexts/modal.context';
import { IModalOptions } from 'interfaces/modal.interface';
import Icon from '../icon/icon.component';
import styles from './modal.module.scss';

interface IModalProps {
  children: React.ReactNode;
  options: IModalOptions;
}

export const Modal = ({ children, options }: IModalProps) => {
  const { title, width, handleCancel } = options;
  const { close } = useModal();
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        handleClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClose = () => {
    if (handleCancel) {
      handleCancel();
    }
    close();
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, options);
    }
    return child;
  });

  return (
    <div className={styles.modal__overlay}>
      <div
        ref={modalRef}
        className={styles.modal__content}
        style={width ? { width: `${width}px` } : undefined}
      >
        <div className={styles.modal__header}>
          <span>{title}</span>
          <button type="button" className={styles.modal__close} onClick={handleClose}>
            <Icon name="CircleX" />
          </button>
        </div>
        <div className={styles.modal__body}>{childrenWithProps}</div>
      </div>
    </div>
  );
};
